// assets/mwc-my-watches.js

(function () {
  if (window.mwcMyWatchesInitialized) return;
  window.mwcMyWatchesInitialized = true;

  function getRoot() {
    return document.getElementById("mwc-my-watches-list");
  }



  function renderEmpty() {
    var root = getRoot();
    if (!root) return;
    root.innerHTML = '<div class="text-xs text-subdued">No watches yet.</div>';
  }

  function renderWatches(items) {
    var root = getRoot();
    if (!root) return;

    if (!items || !items.length) {
      renderEmpty();
      return;
    }

    var templateEl = document.getElementById("mwc-watch-card-template");
    if (!templateEl) {
      root.innerHTML = '<div class="text-xs text-subdued">Template missing.</div>';
      return;
    }

    var template = templateEl.innerHTML;
    var columns = root.getAttribute("data-columns") || 3;

    var html = '<div class="mwc-watch-grid" style="grid-template-columns: repeat(' + columns + ', 1fr);">';

    items.forEach(function (watch) {
      var image = "";

      try {
        var photos = JSON.parse(watch.photos || "[]");
        if (photos.length) {
          image = photos[0];
        }
      } catch (e) {}

if (!image) {
  image = window.mwcAssets.placeholder;
}

      var card = template
        .replace(/__WATCH_ID__/g, watch.id || "")
        .replace(/__WATCH_TITLE__/g, ((watch.brand || "") + " " + (watch.model || "")).trim())
        .replace(/__WATCH_REFERENCE__/g, watch.reference || "")
        .replace(/__WATCH_IMAGE__/g, image)
        .replace(/__WATCH_YEAR__/g, watch.year || "");

      html += card;
    });

    html += "</div>";
    root.innerHTML = html;
  }

  async function loadWatches(userId) {
    var root = getRoot();
    if (!root) return;

    root.innerHTML = '<div class="text-xs text-subdued">Loading...</div>';

    try {
      var data = await MWC.getMyWatches(userId);
      renderWatches(data);
    } catch (e) {
      renderEmpty();
    }
  }

  document.addEventListener("mwc:authenticated", function (e) {
    var detail = e.detail || {};
    if (!detail.user_id) {
      renderEmpty();
      return;
    }

    loadWatches(detail.user_id);
  });

  // ✅ EVENT: nieuwe watch toegevoegd → reload lijst
document.addEventListener("mwc:watch-added", function () {
  MWC.me().then(function (auth) {
    if (auth && auth.user_id) {
      loadWatches(auth.user_id);
    }
  });
});

  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-watch-id]");
    if (!btn) return;

    var id = btn.getAttribute("data-watch-id");
    if (!id) return;

    window.location.href = "/pages/my-watch?id=" + encodeURIComponent(id);
  });
})();


